// extracted by mini-css-extract-plugin
module.exports = {"lds-ring":"Loader_lds-ring__3XAb5"};